export default __webpack_public_path__ + "static/media/jan4.05b57a78.jpg";